import { Component, ojs, v, app } from "modular-openscriptjs";
import { either, formatThousand, monetary } from "../helpers";
import { dc, uc } from "../declarations";
import { dom } from "../fotastart";

const h = app("h");

export default class PaymentMethodList extends Component {
	render(...args) {
		uc.states({
			paymentMethod: "mpesa",
		});

		const renderMethod = (
			value,
			label,
			iconClass,
			description = null,
			extraContent = null
		) => {
			return v(uc.paymentMethod, (currentMethod) => {
				const isSelected = currentMethod.value == value;
				return h.div(
					{
						class: `card shadow-sm rounded-4 cursor-pointer transition-all ${
							isSelected
								? "border-primary bg-primary-subtle"
								: "border-0 bg-white"
						}`,
						onclick: this.method("choose", value),
						style: "transition: all 0.2s ease-in-out;",
					},
					h.div(
						{
							class: "card-body p-3 d-flex align-items-center gap-3",
						},
						h.div(
							{
								class: `rounded-circle d-flex align-items-center justify-content-center ${
									isSelected
										? "bg-primary text-white"
										: "bg-light text-secondary"
								}`,
								style: "width: 48px; height: 48px; min-width: 48px;",
							},
							h.i({ class: `${iconClass} fs-5` })
						),
						h.div(
							{ class: "flex-grow-1" },
							h.div(
								{
									class: "d-flex justify-content-between align-items-center",
								},
								h.h6(
									{ class: "mb-0 fw-bold text-dark" },
									label
								),
								h.div(
									isSelected
										? h.i({
												class: "bi bi-check-circle-fill text-primary fs-4",
										  })
										: h.i({
												class: "bi bi-circle text-muted fs-4",
										  })
								)
							),
							description
								? h.small({ class: "text-muted" }, description)
								: null,
							extraContent
						)
					)
				);
			});
		};

		return h.div(
			{ class: "d-flex flex-column gap-3" },
			h.h5({ class: "fw-bold mb-1 text-secondary" }, "Pay With"),

			renderMethod(
				"capa",
				"My Capa Wallet",
				"bi bi-wallet2",
				null,
				v(uc.capa, (capa) =>
					h.small(
						{ class: "text-primary fw-semibold d-block mt-1" },
						`Balance: ${dc.capaSymbol}${formatThousand(
							capa?.value?.balance ?? 0
						)}`
					)
				)
			),

			renderMethod(
				"mpesa",
				"Lipa Na Mpesa",
				"bi bi-phone",
				"Pay securely via M-Pesa STK Push"
			),

			// Hidden offline payment method
			h.div(
				{ class: "d-none" },
				renderMethod(
					"offlineMpesa",
					"Pay Offline (Mpesa)",
					"bi bi-cash-stack",
					"Manual payment"
				)
			),

			...args
		);
	}

	choose(value) {
		uc.paymentMethod.value = value;
	}
}
